import { Instance } from '../lib/axiosInterceptor';

const USERS_API_BASE = '/api/v1/users';

export const outboundLogsService = {
  getSummary: () => Instance.get(`${USERS_API_BASE}/billing/outbound/logs-summary`),
  getLogs: ({ timezone, limit, lastDocId = '' }) =>
    Instance.get(`${USERS_API_BASE}/billing/outbound/logs?timezone=${timezone}&limit=${limit}&lastDocId=${lastDocId}`),
  getDailySummary: ({ timezone, date }) =>
    Instance.get(`${USERS_API_BASE}/billing/outbound/daily-summary?timezone=${timezone}&date=${date}`),
};
